<template>
    <div>
        <slot name="header"></slot>
        <form class="form-box">
            <div class="row input-box" v-for="(device, key) in devices" :key="key">
                <shop-devices-form-item :device="device" :device-key="key"/>
            </div>
        </form>
        <div class="modal-buttons">
            <button type="button" @click="$emit('close')" class="btn btn-danger mt-3 mr-3">{{$t('COMMON.close')}}</button>
            <!-- <button v-if="devices.length < 3" type="button" @click="devices.push({context, symbol: '', link: '', name: 'Printer Device'})" class="btn btn-primary mt-3">{{$t('COMMON.addDevice')}}</button> -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapMutations, mapGetters, mapActions} from 'vuex';

import FormInput from '../../../components/Shared/UI/Form/FormInput.vue';
import ShopDevicesFormItem from "./ShopDevicesFormItem.vue"

export default {
    name: 'ShopDevicesForm',
    props: {
        devices: { 
            type: Array,
            default: () => []
        },
        context: {
            type: String,
            default: ''
        },
        validator: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            iconSrc: '',
            filestorageURL: `${process.env.VUE_APP_LOCATION}/filestorage`
        }
    },
    components: {
        FormInput,
        ShopDevicesFormItem
    },
    methods: {
        ...mapMutations(['toggleConfirmationModal', 'shouldGoToPrevPageMutation', 'setConfirmationModal']),
        ...mapActions(['DeleteShopDevice']),
        removeShop(device, key) {
            if(device.hasOwnProperty("objectId")) {
                this.setConfirmationModal({
                    callback: () => this.DeleteShopDevice(device),
                    question: 'Are you sure you want to Delete device?',
                });
                this.toggleConfirmationModal(true);
                this.shouldGoToPrevPageMutation(false);
            } else {
                this.devices.splice(key, 1)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .input-box {
        justify-content: center;
        align-items: start;
        border-right: 1px solid #dfdfdf;
        &:nth-child(4n) {
            border-right: none;
        }

        @media (max-width: 600px){
            border-right: none;
            border-bottom: 1px solid #dfdfdf;
            padding-bottom: 30px;
        }

    }
    .form-box {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 25px;
        grid-row-gap: 15px;

        @media (max-width: 1200px){
            grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: 600px){
            grid-template-columns: repeat(1, 1fr);
        }
    }
    .modal-buttons {
        display: flex;
        justify-content: center;
        margin-top: 30px;
    }
    .border-line {
        padding: 20px;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .form-control {
        margin-bottom: 10px;
        &.symbol {
            width: 50%;
        }
    }
    form {
        div.row {
            div.buttons {
                display: flex;
            }
            div.plus {
                display: none;
            }
            &:last-of-type div.buttons div.plus {
                display: flex;
            }
        }
    }
    div.col-2.buttons {
        display: none;
        justify-content: space-around;
        box-sizing: border-box;
        align-items: center;
    }
    div.plus, div.minus {
        font-size: 25px;
        cursor: pointer;
        margin: 0 10px;
        border: 1px solid black;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.5s;
        &.minus {
            &:hover {
                background-color: rgb(225, 38, 74);
            }
        }
    }
    div.image-holder {
        width: 50%;
        height: 100%;
        border: dotted 2px black;
        display: flex;
        justify-content: center;
        align-self: stretch;
        min-height: 100px;
        align-items: center;
        &.placeholder {
            border: dotted #ced4da 2px;
        }
        &.invalid.dirty {
            border-color: red;
        }
        img {
            width: 100%;
        }
    }
</style>

